import { type Ref, onUnmounted, watch } from 'vue'

const SCROLL_LOCK_CLASS = 'sa-modal-scroll-locked'

let lockCount = 0

/** Reference-counted scroll lock so stacked modals do not unlock the page too early. */
function lockBodyScroll(): void {
  if (lockCount === 0) {
    document.documentElement.classList.add(SCROLL_LOCK_CLASS)
    document.body.classList.add(SCROLL_LOCK_CLASS)
  }
  lockCount += 1
}

function unlockBodyScroll(): void {
  if (lockCount <= 0) {
    return
  }

  lockCount -= 1
  if (lockCount > 0) {
    return
  }

  document.documentElement.classList.remove(SCROLL_LOCK_CLASS)
  document.body.classList.remove(SCROLL_LOCK_CLASS)
}

/**
 * Prevents background page scroll while a modal is open.
 * Uses overflow:hidden on the document (Bootstrap modal-open pattern).
 */
export function useModalScrollLock(isOpen: Ref<boolean>): void {
  let isLocked = false

  watch(
    isOpen,
    (open) => {
      if (open && !isLocked) {
        lockBodyScroll()
        isLocked = true
        return
      }

      if (!open && isLocked) {
        unlockBodyScroll()
        isLocked = false
      }
    },
    { immediate: true }
  )

  onUnmounted(() => {
    if (isLocked) {
      unlockBodyScroll()
      isLocked = false
    }
  })
}
